const URL = {
  Home: "/",
  SLA: "/sla",
  SLADetail: "/sla-detail",
  Guide: "/guide",
  Guide1: "/huong-dan-tang-cuong-bao-mat-vps",
  Guide2: "/huong-dan-doi-password-vps-su-dung-windows-server-2012",
  Guide3: "/huong-dan-mo-rong-o-cung-tren-windows-server-va-windows",
  Agreement: "/agreement",
  Contact: "/contact",
  ListServerVN: "/list-server-vn",
  ListServerSG: "/list-server-sg",
  ListServerDE: "/list-server-de",
  ListServerFR: "/list-server-fr",
  ListServerAU: "/list-server-au",
  ListServerUK: "/list-server-uk",
  ListServerUS: "/list-server-us",
  ListServerCA: "/list-server-ca",
  ListServerEU: "/list-server-eu",
  ListServerNL: "/list-server-nl",
  ListVPSGPU: "/list-vps-gpu",
  ListProxyVN: "/list-proxy-vn",
  ListProxySG: "/list-proxy-sg",
  ListProxyDE: "/list-proxy-de",
  ListProxyFR: "/list-proxy-fr",
  ListProxyAU: "/list-proxy-au",
  ListProxyUK: "/list-proxy-uk",
  ListProxyUS: "/list-proxy-us",
  ListProxyCA: "/list-proxy-ca",
  ListProxyNL: "/list-proxy-nl",
  ListDedicatedServerEU: "/list-dedicated-server-eu",
  ListDedicatedServerUS: "/list-dedicated-server-us",
  List922S5Proxy: "/list-922-s5proxy",
  ListPIAS5Proxy: "/list-pia-s5proxy",
  BuyProduct: "https://manage.timecloud.vn/buying?type=VPS&nation=VN",
  Login: "https://manage.timecloud.vn",
  Register: "https://manage.timecloud.vn/register",
  ProductManagement:
    "https://manage.timecloud.vn/management?type=VPS&by_time=using",
  NotFound: "*",
};

export default URL;
